import AppSimpleBar from "components/AppSimpleBar";
import UserAvatar from "components/UserAvatar";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import classnames from "classnames";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import Loader from "components/Loader";
import { useEffect, useState } from "react";
import { changeSelectedContentTitleKeyId, changeSelectedContentTitle, reduceContentTitleUnread, setActiveWebUserId } from "../../../redux/actions";
import classNames from "classnames";
import { CONTENT_TITLE_NAME } from "../../../constants";
import { ThirdApi } from "api/apiThird";
import { getWebUserId } from "api";
import { APIClient } from "api/apiCore";
import * as urls from "api/urls";
import { Const } from "const";
import { sp_GetWebUserId } from "types";
import MyMap from "components/MyMap";


interface ContentDeliveryMapProps {
  contentTitleDetails: any;
}

const ContentDeliveryMap = ({ contentTitleDetails }: ContentDeliveryMapProps) => {

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>("");
  const [mapData, setMapData] = useState<any>(null);

  useEffect(() => {
    console.log('ContentDeliveryMap Loading...');
    try {
      console.log('contentTitleDetails:', contentTitleDetails);
      const [branchId, ssCode] = contentTitleDetails.keyId.split("||");
      const api = new APIClient;
      setIsLoading(true);
      api.fnPostForm(urls.GET_CTN_ISSUE_ORDER_WAIT_DELIVERY_TINFO, { branchId, ssCode })
        .then(rs => {
          if (rs) {
            console.log('gps info:', rs);
            setMapData({
              ssTruckID: rs.ssTruckID,
              ssTruckCode: rs.ssTruckCode,
              gpsLat: Utils.ToNumber(rs.gpsLat, 0),
              gpsLng: Utils.ToNumber(rs.gpsLng, 0),
              gpsHeading: Utils.ToNumber(rs.gpsHeading, 0),
              gpsInfo: rs.gpsInfo,

              ssLat: Utils.ToNumber(rs.ssLat, 0),
              ssLng: Utils.ToNumber(rs.ssLng, 0),

            });
          } else {
            setErrMsg("Data not found");
          }
          setIsLoading(false);
        })
        .catch(er => {
          setErrMsg(Utils.GetMessageFromExecption(er));
          setIsLoading(false);
        });

    } catch (e) {
      setErrMsg(Utils.GetMessageFromExecption(e));
      setIsLoading(false);
    }

  }, []);
  // console.log('mapData:', mapData);
  return (
    <>
      {errMsg && (<span className="text-red">{errMsg}</span>)}
      {isLoading && (<>กำลังโหลดข้อมูล...</>)}
      {isLoading && (<Loader />)}

      {mapData && (
        <MyMap headerHeight={200}
          truckHeading={mapData.gpsHeading}
          lat={mapData.gpsLat}
          lng={mapData.gpsLng}
          desLat={mapData.ssLat}
          desLng={mapData.ssLng}
          // infoTitle={mapData.titleR1}
          // infoLine1="49/01 ม. 5 ต. บ้านท่าช้าง อ. บางพลัดพราก จ. แล้วเจอกันใหม่ 90110"
          // infoLine2="ok นะจ๊ะ"
          infoHtml={mapData.gpsInfo}
        />
      )}

    </>
  );
}

export default ContentDeliveryMap;